<template>
    <div class="relative w-120 flex h-full flex-col max-mob:w-auto">
        <div class="pb-4 w-full flex justify-between border-b border-gray-100 dark:border-gray-730">
            <div class="">
                <div class="text-lg font-medium text-gray-370 dark:text-white">
                    Verify Your Account
                </div>

                <div class="pt-2.5 text-xs text-gray-280 dark:text-gray-190">
                    To upgrade plan please review the information in the next steps
                </div>
            </div>

            <CloseIconMini
                v-if="!isAccountTrialEnded"
                class="text-gray-200 cursor-pointer"
                @click="close"
            />
        </div>

        <StepList
            class="w-full mt-7 mb-6 max-mob:mb-7"
            :items="Object.values(VERIFICATION_STEPS)"
            :currentStep="currentStep"
            showDividers
        />

        <component
            :is="currentStepComponent"
            @nextStep="nextStep"
            @prevStep="prevStep"
        />
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'

import CloseIconMini from '@/components/icons/CloseIconMini.vue'
import StepList from '@/components/steps/StepList.vue'
import BillingTypeStep from '@/views/verification/steps/BillingTypeStep.vue'
import DocumentStep from '@/views/verification/steps/DocumentStep.vue'
import PaymentMethodStep from '@/views/verification/steps/PaymentMethodStep.vue'

import { useAuthorizationStore } from '@/store/authorizationStore'
import { useVerificationUserStore } from '@/store/call-tracking/verificationUserStore'

import { VERIFICATION_STEPS, STATUSES } from '@/constants/verification'

const emits = defineEmits(['close', 'nextStep', 'openReviewView'])

const authorizationStore = useAuthorizationStore()
const verificationUserStore = useVerificationUserStore()

const currentStep = ref(VERIFICATION_STEPS.billingType.id)

const isAccountTrialEnded = computed(() => authorizationStore.isAccountTrialEnded)

const currentStepComponent = computed(() => {
    switch (currentStep.value) {
    case VERIFICATION_STEPS.billingType.id:
        return BillingTypeStep
    case VERIFICATION_STEPS.kyc.id:
        return DocumentStep
    case VERIFICATION_STEPS.payment_method.id:
        return PaymentMethodStep
    }
})

onMounted(() => {
    setCurrentStep()
})

function setCurrentStep() {
    if (verificationUserStore.reviewStep) {
        switch (true) {
        case verificationUserStore.reviewStep === VERIFICATION_STEPS.kyc.id:
            return currentStep.value = VERIFICATION_STEPS.kyc.id
        case verificationUserStore.reviewStep === VERIFICATION_STEPS.payment_method.id:
            return currentStep.value = VERIFICATION_STEPS.payment_method.id
        }
    }

    switch (true) {
    case verificationUserStore.kycStepDone && verificationUserStore.kycStepStatus !== STATUSES.rejected.id:
        return currentStep.value = VERIFICATION_STEPS.payment_method.id
    case verificationUserStore.billingStepDone:
        return currentStep.value = VERIFICATION_STEPS.kyc.id
    }
}

function prevStep() {
    switch (currentStep.value) {
    case VERIFICATION_STEPS.kyc.id:
        return currentStep.value = VERIFICATION_STEPS.billingType.id
    case VERIFICATION_STEPS.payment_method.id:
        return currentStep.value = VERIFICATION_STEPS.kyc.id
    }
}

function nextStep(value) {
    if (
        currentStep.value === VERIFICATION_STEPS.payment_method.id
        || (currentStep.value === VERIFICATION_STEPS.kyc.id && verificationUserStore.paymentStepDone && verificationUserStore.paymentStepStatus !== STATUSES.rejected.id)
    ) {
        verificationUserStore.setReviewStep(null)

        emits('openReviewView')

        return
    }

    currentStep.value = value
}

function close() {
    emits('close')
}
</script>
